export const sortByName = (a, b) => a.name.localeCompare(b.name);

export const sortByOrder = (a, b) => a.sortOrder - b.sortOrder;
